"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractKeyRegistry = exports.ETH_KEY_REGISTRY_SEED_PREFIX = exports.KEY_REGISTRY_SEED_PREFIX = void 0;
const sol_did_client_1 = require("@identity.com/sol-did-client");
const CommonRegistry_1 = require("../../lib/CommonRegistry");
exports.KEY_REGISTRY_SEED_PREFIX = "key_registry";
exports.ETH_KEY_REGISTRY_SEED_PREFIX = "eth_key_registry";
class AbstractKeyRegistry extends CommonRegistry_1.CommonRegistry {
    constructor(address, seedPrefix, cluster) {
        super(address, seedPrefix, cluster);
    }
    /**
     * Given a did count, calculate the size in bytes of the registry required to store it.
     *
     * NOTE: This must stay in sync with KeyRegistry::calculate_size in the program.
     */
    static calculateMaxCount(sizeInBytes) {
        const didSpace = sizeInBytes -
            8 - // discriminator
            1 - // version
            32 - // key
            4; // vec length field
        return Math.floor(didSpace / 32);
    }
    /**
     * Given a registry, analyse how many DIDs it contains, and how many it can store
     * @protected
     */
    analyseSpace() {
        return __awaiter(this, void 0, void 0, function* () {
            const registryAccountInfo = yield this.program.account.keyRegistry.getAccountInfo(this.registryAddress);
            if (!registryAccountInfo)
                return { count: 0, maxCount: 0, sizeBytes: 0 };
            const sizeBytes = registryAccountInfo.data.length;
            const coder = this.program.account.keyRegistry.coder.accounts;
            const account = coder.decode("keyRegistry", registryAccountInfo.data);
            const didCount = account.dids.length;
            const maxCount = AbstractKeyRegistry.calculateMaxCount(sizeBytes);
            return { count: didCount, maxCount, sizeBytes };
        });
    }
    listDIDs() {
        return __awaiter(this, void 0, void 0, function* () {
            const registryAccount = yield this.program.account.keyRegistry.fetchNullable(this.registryAddress);
            if (!registryAccount)
                return [];
            return registryAccount.dids.map((identifier) => sol_did_client_1.DidSolIdentifier.create(identifier, this.cluster).toString());
        });
    }
}
exports.AbstractKeyRegistry = AbstractKeyRegistry;
//# sourceMappingURL=AbstractKeyRegistry.js.map